import moment from "moment";
import { destroy, get } from "../api";

/**
 * Impact notification pauses: a burst of impacts pauses a device's impact and
 * orientation alerts for a while on the server, and a signed-in user can end
 * the pause early (shown to users as "Resume"). Shared by the asset card's
 * "Paused · Resume" note and the prompt the pause email opens.
 */

/** The query parameter the pause email adds to the asset link: /assets/9/?resume=1 */
export const RESUME_PARAM = "resume";

/** Fired on window after a device is unpaused, so every view of it can refresh. */
export const NOTIFICATION_PAUSE_CHANGED = "sentinel:notification-pause-changed";

export const isActivePause = (pause) =>
  Boolean(pause) && moment.utc(pause.paused_until).isAfter(moment());

/** The device's pause while it is still running, else null. Never sends the user to the error page. */
export async function fetchActivePause(deviceId) {
  const res = await get(`/devices/${deviceId}/notification_pause`, {}, false);
  const pause = res && res.status === 200 ? await res.json() : null;
  return isActivePause(pause) ? pause : null;
}

/** Ends the device's pause now. True when the server took it. */
export async function unpauseDevice(deviceId) {
  const res = await destroy(`/devices/${deviceId}/notification_pause`);
  const ok = Boolean(res && res.ok);
  if (ok) {
    window.dispatchEvent(
      new CustomEvent(NOTIFICATION_PAUSE_CHANGED, { detail: { deviceId } })
    );
  }
  return ok;
}

/** "1 hour", "2 hours" or "45 minutes". */
export const spanText = (minutes) =>
  minutes % 60 === 0
    ? `${minutes / 60} hour${minutes === 60 ? "" : "s"}`
    : `${minutes} minutes`;

/** "9:06pm" today, else "Oct 19, 9:06pm", in the viewer's time. */
export const pausedUntilText = (until) => {
  const local = moment.utc(until).local();
  return local.isSame(moment(), "day")
    ? local.format("h:mma")
    : local.format("MMM D, h:mma");
};
